import React, { useEffect } from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import BackButton from '../components/common/BackButton';

const TermsConditions = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <BackButton />
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
              Terms & Conditions
            </h1>

            <div className="prose prose-lg max-w-none space-y-6">
              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  1. DSA Services
                </h2>
                <p className="text-gray-800 leading-relaxed mb-4" style={{ fontSize: '14px' }}>
                  We, <strong>Prajwal Jadhav and Nikita Bansod / Shravi Finance</strong> (Individual DSA), act only as a Direct Selling Agent (DSA) / Channel Partner. We do not provide loans directly. We only assist in connecting customers with RBI-regulated partner banks and NBFCs such as SBI, HDFC Bank, Bajaj Finserv, etc.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  2. Loan Approval & Terms
                </h2>
                <p className="text-gray-800 leading-relaxed mb-4" style={{ fontSize: '14px' }}>
                  Loan approval, interest rates, EMIs, processing fees, tenure, and all loan terms are decided exclusively by the partner lenders (RBI-regulated banks/NBFCs). We do not guarantee loan approval. All loan terms are governed by RBI Digital Lending Guidelines and individual lender policies.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  3. Consent for Communication
                </h2>
                <p className="text-gray-800 leading-relaxed mb-4" style={{ fontSize: '14px' }}>
                  By submitting the loan application form, you consent to receive calls, SMS, WhatsApp messages, and emails from us and our partner lenders regarding loan offers, pre-approvals, and related services. You can opt-out of marketing communications at any time.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  4. Fees & Charges
                </h2>
                <p className="text-gray-800 leading-relaxed mb-4" style={{ fontSize: '14px' }}>
                  All fees, charges, and costs (including processing fees, prepayment charges, etc.) are disclosed by the lenders before loan disbursement as per RBI guidelines. We do not charge any hidden fees. Compare offers from different lenders before applying.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  5. Eligibility Criteria
                </h2>
                <p className="text-gray-800 leading-relaxed mb-4" style={{ fontSize: '14px' }}>
                  Loan approval depends on lender eligibility criteria, CIBIL score, income, KYC documentation, and other factors as determined by the lender. Not all applicants qualify. We do not guarantee loan approval or specific interest rates.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  6. Data Sharing
                </h2>
                <p className="text-gray-800 leading-relaxed mb-4" style={{ fontSize: '14px' }}>
                  Your personal information will be shared ONLY with selected partner banks/NBFCs for loan processing. We do not sell or misuse your data. We are compliant with DPDP Act, 2023 and RBI data protection norms. For details, please refer to our <a href="#/privacy-policy" className="text-primary-600 hover:underline font-semibold">Privacy Policy</a>.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  7. Grievance Redressal
                </h2>
                <p className="text-gray-800 leading-relaxed mb-4" style={{ fontSize: '14px' }}>
                  For any complaints or grievances:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-800 mb-4" style={{ fontSize: '14px' }}>
                  <li>Contact us at <strong>shravifinance@gmail.com</strong> or call <strong>+91 8668272248</strong> / <strong>+91 7020113728</strong></li>
                  <li>Lodge complaints with the respective lender</li>
                  <li>Use RBI Sachet Portal: <a href="https://sachet.rbi.org.in/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline font-semibold">https://sachet.rbi.org.in/</a></li>
                  <li>Use RBI Complaint Management System: <a href="https://cms.rbi.org.in" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline font-semibold">https://cms.rbi.org.in</a></li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  8. Compliance
                </h2>
                <p className="text-gray-800 leading-relaxed mb-4" style={{ fontSize: '14px' }}>
                  We operate in compliance with:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-800 mb-4" style={{ fontSize: '14px' }}>
                  <li>RBI Digital Lending Guidelines</li>
                  <li>RBI Fair Practices Code</li>
                  <li>DPDP Act, 2023</li>
                  <li>Information Technology Act, 2000</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  9. Governing Law
                </h2>
                <p className="text-gray-800 leading-relaxed mb-4" style={{ fontSize: '14px' }}>
                  These Terms & Conditions are governed by the laws of India. Any disputes shall be subject to the jurisdiction of courts in Nagpur, Maharashtra, India.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  10. Contact Information
                </h2>
                <div className="bg-gray-50 p-4 rounded-lg" style={{ fontSize: '14px' }}>
                  <p className="text-gray-800 mb-2">
                    <strong>Address:</strong> 2nd Floor, 157/116, Beside Shri Krishna Mandir, Opp. Techops Grand, Ayodhya Nagar Rd, Chakradhar Nagar, Nagpur – 440024
                  </p>
                  <p className="text-gray-800 mb-2">
                    <strong>Email:</strong> <a href="mailto:shravifinance@gmail.com" className="text-primary-600 hover:underline">shravifinance@gmail.com</a>
                  </p>
                  <p className="text-gray-800 mb-2">
                    <strong>Phone:</strong> <a href="tel:+918668272248" className="text-primary-600 hover:underline">+91 8668272248</a> / <a href="tel:+917020113728" className="text-primary-600 hover:underline">+91 7020113728</a>
                  </p>
                  <p className="text-gray-800">
                    <strong>Working Hours:</strong> 10:30 AM – 7:00 PM (IST)
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsConditions;

